import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  Table,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import styled from "@emotion/styled";
import { useMemo, useState } from "react";
import Audio from "react-loading-icons/dist/esm/components/audio";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
    padding: "5px 0",
  },
}));

const TableStyled = ({
  headers = [],
  data = [],
  name = "name",
  loading = false,
  onRowClick,
}) => {
  // { ref, direction } | null — ref es sortRef si el header lo define, o ref
  const [sortConfig, setSortConfig] = useState(null);

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  };

  // Valor comparable para ordenar: fechas como timestamp, números como
  // número, y el resto como texto en minúsculas (case-insensitive).
  const getSortValue = (item, ref) => {
    const raw = item[ref];
    if (["start_discount", "end_discount"].includes(ref))
      return raw ? new Date(raw).getTime() : 0;
    if (raw === null || raw === undefined || raw === "") return "";
    if (typeof raw === "number") return raw;
    const num = Number(raw);
    return Number.isNaN(num) ? String(raw).toLowerCase() : num;
  };

  const handleSort = (header) => {
    const key = header.sortRef || header.ref;
    setSortConfig((prev) => {
      if (!prev || prev.ref !== key) return { ref: key, direction: "asc" };
      return { ref: key, direction: prev.direction === "asc" ? "desc" : "asc" };
    });
  };

  const dataOrdenada = useMemo(() => {
    if (!sortConfig) return data;
    const copia = [...data];
    copia.sort((a, b) => {
      const va = getSortValue(a, sortConfig.ref);
      const vb = getSortValue(b, sortConfig.ref);
      if (va < vb) return sortConfig.direction === "asc" ? -1 : 1;
      if (va > vb) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return copia;
  }, [data, sortConfig]);

  return (
    <>
      <Stack>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header, i) => {
                const key = header.sortRef || header.ref;
                const activo = sortConfig?.ref === key;
                return (
                  <StyledTableCell
                    key={i}
                    onClick={() => handleSort(header)}
                    sx={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
                  >
                    {header.label}
                    {activo &&
                      (sortConfig.direction === "asc" ? (
                        <ArrowUpwardIcon
                          sx={{ fontSize: 14, verticalAlign: "middle", ml: 0.5 }}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          sx={{ fontSize: 14, verticalAlign: "middle", ml: 0.5 }}
                        />
                      ))}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && data.length === 0 && (
              <TableRow>
                <StyledTableCell colSpan={headers.length}>
                  <Audio fill="#F27224" />
                </StyledTableCell>
              </TableRow>
            )}

            {!loading && data.length === 0 ? (
              <TableRow>
                <StyledTableCell colSpan={headers.length}>
                  <Typography variant="h5">No hay resultados</Typography>
                </StyledTableCell>
              </TableRow>
            ) : (
              dataOrdenada.map((item, i) => (
                <TableRow
                  key={i}
                  onClick={onRowClick ? () => onRowClick(item) : undefined}
                  sx={{
                    ":hover": {
                      backgroundColor: "#f1f1f1",
                      cursor: "pointer",
                    },
                  }}
                >
                  {headers.map(({ ref, render }, index) => (
                    <StyledTableCell
                      key={index}
                      sx={{ fontWeight: index === 0 ? 700 : 400 }}
                    >
                      {render
                        ? render(item)
                        : ["start_discount", "end_discount"].includes(ref)
                        ? formatDate(item[ref])
                        : ref === "radar_coin"
                        ? item[ref] + " RC"
                        : item[ref]}
                    </StyledTableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Stack>
    </>
  );
};

export default TableStyled;
